// Falls back to a static image when the device blocks video autoplay (iOS Low Power Mode, data saver).
(function () {
  function showFallback(video) {
    var media = video.closest('.banner__media');
    var fallback = media && media.querySelector('.av-video-banner__fallback');
    if (!fallback) return;

    video.pause();
    video.removeAttribute('autoplay');
    fallback.removeAttribute('hidden');
    media.classList.add('av-video-banner--fallback-active');
  }

  function initVideo(video) {
    if (video.dataset.avVideoBannerInit === 'true') return;
    video.dataset.avVideoBannerInit = 'true';

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        showFallback(video);
      });
    }

    // Safety net for browsers that resolve play() but never actually advance
    setTimeout(function () {
      if (video.paused) showFallback(video);
    }, 600);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-av-video-banner]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
